"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EMOJI_NAME_MAP = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _AdmissionTickets = _interopRequireDefault(require("../../../asset/emoji/AdmissionTickets.svg"));

var _Airplane = _interopRequireDefault(require("../../../asset/emoji/Airplane.svg"));

var _AlarmClock = _interopRequireDefault(require("../../../asset/emoji/AlarmClock.svg"));

var _AlienMonster = _interopRequireDefault(require("../../../asset/emoji/AlienMonster.svg"));

var _Ambulance = _interopRequireDefault(require("../../../asset/emoji/Ambulance.svg"));

var _Anchor = _interopRequireDefault(require("../../../asset/emoji/Anchor.svg"));

var _ArticulatedLorry = _interopRequireDefault(require("../../../asset/emoji/ArticulatedLorry.svg"));

var _ArtistPalette = _interopRequireDefault(require("../../../asset/emoji/ArtistPalette.svg"));

var _Automobile = _interopRequireDefault(require("../../../asset/emoji/Automobile.svg"));

var _AutoRickshaw = _interopRequireDefault(require("../../../asset/emoji/AutoRickshaw.svg"));

var _BalanceScale = _interopRequireDefault(require("../../../asset/emoji/BalanceScale.svg"));

var _Bank = _interopRequireDefault(require("../../../asset/emoji/Bank.svg"));

var _Battery = _interopRequireDefault(require("../../../asset/emoji/Battery.svg"));

var _Bear = _interopRequireDefault(require("../../../asset/emoji/Bear.svg"));

var _Bearings = _interopRequireDefault(require("../../../asset/emoji/Bearings.svg"));

var _Bearish = _interopRequireDefault(require("../../../asset/emoji/Bearish.svg"));

var _BeerMug = _interopRequireDefault(require("../../../asset/emoji/BeerMug.svg"));

var _BellhopBell = _interopRequireDefault(require("../../../asset/emoji/BellhopBell.svg"));

var _Bird = _interopRequireDefault(require("../../../asset/emoji/Bird.svg"));

var _Blackbox = _interopRequireDefault(require("../../../asset/emoji/Blackbox.svg"));

var _Bolt = _interopRequireDefault(require("../../../asset/emoji/Bolt.svg"));

var _BPO = _interopRequireDefault(require("../../../asset/emoji/BPO.svg"));

var _Bread = _interopRequireDefault(require("../../../asset/emoji/Bread.svg"));

var _Brick = _interopRequireDefault(require("../../../asset/emoji/Brick.svg"));

var _Bullish = _interopRequireDefault(require("../../../asset/emoji/Bullish.svg"));

var _BuildingConstruction = _interopRequireDefault(require("../../../asset/emoji/BuildingConstruction.svg"));

var _Cash = _interopRequireDefault(require("../../../asset/emoji/Cash.svg"));

var _CatFace = _interopRequireDefault(require("../../../asset/emoji/CatFace.svg"));

var _Ceramics = _interopRequireDefault(require("../../../asset/emoji/Ceramics.svg"));

var _ChartDecreasing = _interopRequireDefault(require("../../../asset/emoji/ChartDecreasing.svg"));

var _ChartIncreasing = _interopRequireDefault(require("../../../asset/emoji/ChartIncreasing.svg"));

var _Chemicals = _interopRequireDefault(require("../../../asset/emoji/Chemicals.svg"));

var _ChequeredFlag = _interopRequireDefault(require("../../../asset/emoji/ChequeredFlag.svg"));

var _CherryBlossom = _interopRequireDefault(require("../../../asset/emoji/CherryBlossom.svg"));

var _ChessHorse = _interopRequireDefault(require("../../../asset/emoji/ChessHorse.svg"));

var _ChessPawn = _interopRequireDefault(require("../../../asset/emoji/ChessPawn.svg"));

var _Cigarette = _interopRequireDefault(require("../../../asset/emoji/Cigarette.svg"));

var _ClapperBoard = _interopRequireDefault(require("../../../asset/emoji/ClapperBoard.svg"));

var _ClappingHands = _interopRequireDefault(require("../../../asset/emoji/ClappingHands.svg"));

var _ClosedBook = _interopRequireDefault(require("../../../asset/emoji/ClosedBook.svg"));

var _Cloud = _interopRequireDefault(require("../../../asset/emoji/Cloud.svg"));

var _Collision = _interopRequireDefault(require("../../../asset/emoji/Collision.svg"));

var _Crown = _interopRequireDefault(require("../../../asset/emoji/Crown.svg"));

var _Compass = _interopRequireDefault(require("../../../asset/emoji/Compass.svg"));

var _Construction = _interopRequireDefault(require("../../../asset/emoji/Construction.svg"));

var _Controller = _interopRequireDefault(require("../../../asset/emoji/Controller.svg"));

var _CowboyHatFace = _interopRequireDefault(require("../../../asset/emoji/CowboyHatFace.svg"));

var _CreditCard = _interopRequireDefault(require("../../../asset/emoji/CreditCard.svg"));

var _CricketGame = _interopRequireDefault(require("../../../asset/emoji/CricketGame.svg"));

var _CrystalBall = _interopRequireDefault(require("../../../asset/emoji/CrystalBall.svg"));

var _Cycle = _interopRequireDefault(require("../../../asset/emoji/Cycle.svg"));

var _DeciduousTree = _interopRequireDefault(require("../../../asset/emoji/DeciduousTree.svg"));

var _Defence = _interopRequireDefault(require("../../../asset/emoji/Defence.svg"));

var _DesertIsland = _interopRequireDefault(require("../../../asset/emoji/DesertIsland.svg"));

var _DomesticApplicances = _interopRequireDefault(require("../../../asset/emoji/DomesticApplicances.svg"));

var _EarOfCorn = _interopRequireDefault(require("../../../asset/emoji/EarOfCorn.svg"));

var _Eye = _interopRequireDefault(require("../../../asset/emoji/Eye.svg"));

var _Factory = _interopRequireDefault(require("../../../asset/emoji/Factory.svg"));

var _Feather = _interopRequireDefault(require("../../../asset/emoji/Feather.svg"));

var _Ferry = _interopRequireDefault(require("../../../asset/emoji/Ferry.svg"));

var _Fire = _interopRequireDefault(require("../../../asset/emoji/Fire.svg"));

var _Fish = _interopRequireDefault(require("../../../asset/emoji/Fish.svg"));

var _FlagIndia = _interopRequireDefault(require("../../../asset/emoji/FlagIndia.svg"));

var _FlagInHole = _interopRequireDefault(require("../../../asset/emoji/FlagInHole.svg"));

var _FlexedBiceps = _interopRequireDefault(require("../../../asset/emoji/FlexedBiceps.svg"));

var _FlyingSaucer = _interopRequireDefault(require("../../../asset/emoji/FlyingSaucer.svg"));

var _ForkAndKnife = _interopRequireDefault(require("../../../asset/emoji/ForkAndKnife.svg"));

var _FourLeafClover = _interopRequireDefault(require("../../../asset/emoji/FourLeafClover.svg"));

var _FrenchFries = _interopRequireDefault(require("../../../asset/emoji/FrenchFries.svg"));

var _FuelPump = _interopRequireDefault(require("../../../asset/emoji/FuelPump.svg"));

var _GemStone = _interopRequireDefault(require("../../../asset/emoji/GemStone.svg"));

var _Glass = _interopRequireDefault(require("../../../asset/emoji/Glass.svg"));

var _GlobeShowingAsiaAustralia = _interopRequireDefault(require("../../../asset/emoji/GlobeShowingAsiaAustralia.svg"));

var _GraduationCap = _interopRequireDefault(require("../../../asset/emoji/GraduationCap.svg"));

var _HotBeverage = _interopRequireDefault(require("../../../asset/emoji/HotBeverage.svg"));

var _HouseWithGarden = _interopRequireDefault(require("../../../asset/emoji/HouseWithGarden.svg"));

var _IT = _interopRequireDefault(require("../../../asset/emoji/IT.svg"));

var _LeafFlutteringInWind = _interopRequireDefault(require("../../../asset/emoji/LeafFlutteringInWind.svg"));

var _Leather = _interopRequireDefault(require("../../../asset/emoji/Leather.svg"));

var _LightBulb = _interopRequireDefault(require("../../../asset/emoji/LightBulb.svg"));

var _Lipstick = _interopRequireDefault(require("../../../asset/emoji/Lipstick.svg"));

var _Locked = _interopRequireDefault(require("../../../asset/emoji/Locked.svg"));

var _Metal = _interopRequireDefault(require("../../../asset/emoji/Metal.svg"));

var _Microphone = _interopRequireDefault(require("../../../asset/emoji/Microphone.svg"));

var _Microscope = _interopRequireDefault(require("../../../asset/emoji/Microscope.svg"));

var _MobilePhone = _interopRequireDefault(require("../../../asset/emoji/MobilePhone.svg"));

var _MoneyMouthFace = _interopRequireDefault(require("../../../asset/emoji/MoneyMouthFace.svg"));

var _MoneyWithWings = _interopRequireDefault(require("../../../asset/emoji/MoneyWithWings.svg"));

var _Mountain = _interopRequireDefault(require("../../../asset/emoji/Mountain.svg"));

var _Neutral = _interopRequireDefault(require("../../../asset/emoji/Neutral.svg"));

var _Newspaper = _interopRequireDefault(require("../../../asset/emoji/Newspaper.svg"));

var _OilBarrel = _interopRequireDefault(require("../../../asset/emoji/OilBarrel.svg"));

var _Ox = _interopRequireDefault(require("../../../asset/emoji/Ox.svg"));

var _Packaging = _interopRequireDefault(require("../../../asset/emoji/Packaging.svg"));

var _Paint = _interopRequireDefault(require("../../../asset/emoji/Paint.svg"));

var _Paper = _interopRequireDefault(require("../../../asset/emoji/Paper.svg"));

var _PartyPopper = _interopRequireDefault(require("../../../asset/emoji/PartyPopper.svg"));

var _Pencil = _interopRequireDefault(require("../../../asset/emoji/Pencil.svg"));

var _PerformingArts = _interopRequireDefault(require("../../../asset/emoji/PerformingArts.svg"));

var _Petrol = _interopRequireDefault(require("../../../asset/emoji/Petrol.svg"));

var _Photo = _interopRequireDefault(require("../../../asset/emoji/Photo.svg"));

var _Pill = _interopRequireDefault(require("../../../asset/emoji/Pill.svg"));

var _PlasticBucket = _interopRequireDefault(require("../../../asset/emoji/PlasticBucket.svg"));

var _Plug = _interopRequireDefault(require("../../../asset/emoji/Plug.svg"));

var _PoliceCarLight = _interopRequireDefault(require("../../../asset/emoji/PoliceCarLight.svg"));

var _Pool8Ball = _interopRequireDefault(require("../../../asset/emoji/Pool8Ball.svg"));

var _Popcorn = _interopRequireDefault(require("../../../asset/emoji/Popcorn.svg"));

var _Printers = _interopRequireDefault(require("../../../asset/emoji/Printers.svg"));

var _PurpleHeart = _interopRequireDefault(require("../../../asset/emoji/PurpleHeart.svg"));

var _Rainbow = _interopRequireDefault(require("../../../asset/emoji/Rainbow.svg"));

var _RecyclingSymbol = _interopRequireDefault(require("../../../asset/emoji/RecyclingSymbol.svg"));

var _Rocket = _interopRequireDefault(require("../../../asset/emoji/Rocket.svg"));

var _Rubber = _interopRequireDefault(require("../../../asset/emoji/Rubber.svg"));

var _RubberButton = _interopRequireDefault(require("../../../asset/emoji/RubberButton.svg"));

var _SafetyVest = _interopRequireDefault(require("../../../asset/emoji/SafetyVest.svg"));

var _Satellite = _interopRequireDefault(require("../../../asset/emoji/Satellite.svg"));

var _Shark = _interopRequireDefault(require("../../../asset/emoji/Shark.svg"));

var _Shield = _interopRequireDefault(require("../../../asset/emoji/Shield.svg"));

var _Shoes = _interopRequireDefault(require("../../../asset/emoji/Shoes.svg"));

var _ShootingStar = _interopRequireDefault(require("../../../asset/emoji/ShootingStar.svg"));

var _ShoppingBags = _interopRequireDefault(require("../../../asset/emoji/ShoppingBags.svg"));

var _ShoppingCart = _interopRequireDefault(require("../../../asset/emoji/ShoppingCart.svg"));

var _Soap = _interopRequireDefault(require("../../../asset/emoji/Soap.svg"));

var _SoccerBall = _interopRequireDefault(require("../../../asset/emoji/SoccerBall.svg"));

var _SportsMedal = _interopRequireDefault(require("../../../asset/emoji/SportsMedal.svg"));

var _Stadium = _interopRequireDefault(require("../../../asset/emoji/Stadium.svg"));

var _Star = _interopRequireDefault(require("../../../asset/emoji/Star.svg"));

var _StarStruck = _interopRequireDefault(require("../../../asset/emoji/StarStruck.svg"));

var _Station = _interopRequireDefault(require("../../../asset/emoji/Station.svg"));

var _Stethoscope = _interopRequireDefault(require("../../../asset/emoji/Stethoscope.svg"));

var _Sugar = _interopRequireDefault(require("../../../asset/emoji/Sugar.svg"));

var _Textile = _interopRequireDefault(require("../../../asset/emoji/Textile.svg"));

var _Thermometer = _interopRequireDefault(require("../../../asset/emoji/Thermometer.svg"));

var _ThoughtBalloon = _interopRequireDefault(require("../../../asset/emoji/ThoughtBalloon.svg"));

var _Toolbox = _interopRequireDefault(require("../../../asset/emoji/Toolbox.svg"));

var _Tractor = _interopRequireDefault(require("../../../asset/emoji/Tractor.svg"));

var _Travel = _interopRequireDefault(require("../../../asset/emoji/Travel.svg"));

var _Trophy = _interopRequireDefault(require("../../../asset/emoji/Trophy.svg"));

var _Truck = _interopRequireDefault(require("../../../asset/emoji/Truck.svg"));

var _TwoHearts = _interopRequireDefault(require("../../../asset/emoji/TwoHearts.svg"));

var _Volatile = _interopRequireDefault(require("../../../asset/emoji/Volatile.svg"));

var _Watch = _interopRequireDefault(require("../../../asset/emoji/Watch.svg"));

var _Wood = _interopRequireDefault(require("../../../asset/emoji/Wood.svg"));

var _WoodDoor = _interopRequireDefault(require("../../../asset/emoji/WoodDoor.svg"));

var _UmbrellaWithRainDrops = _interopRequireDefault(require("../../../asset/emoji/UmbrellaWithRainDrops.svg"));

var _Wrench = _interopRequireDefault(require("../../../asset/emoji/Wrench.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const EMOJI_NAME_MAP = {
  admission_tickets: _AdmissionTickets.default,
  airplane: _Airplane.default,
  alarm_clock: _AlarmClock.default,
  alien_monster: _AlienMonster.default,
  ambulance: _Ambulance.default,
  anchor: _Anchor.default,
  articulated_lorry: _ArticulatedLorry.default,
  artist_palette: _ArtistPalette.default,
  automobile: _Automobile.default,
  auto_rickshaw: _AutoRickshaw.default,
  balance_scale: _BalanceScale.default,
  bank: _Bank.default,
  battery: _Battery.default,
  bear: _Bear.default,
  bearings: _Bearings.default,
  bearish: _Bearish.default,
  beer_mug: _BeerMug.default,
  bellhop_bell: _BellhopBell.default,
  bird: _Bird.default,
  black_box: _Blackbox.default,
  bolt: _Bolt.default,
  bpo: _BPO.default,
  bread: _Bread.default,
  brick: _Brick.default,
  building_construction: _BuildingConstruction.default,
  bullish: _Bullish.default,
  cash: _Cash.default,
  cat_face: _CatFace.default,
  ceramics: _Ceramics.default,
  chart_decreasing: _ChartDecreasing.default,
  chart_increasing: _ChartIncreasing.default,
  chemicals: _Chemicals.default,
  chequered_flag: _ChequeredFlag.default,
  cherry_blossom: _CherryBlossom.default,
  chess_horse: _ChessHorse.default,
  chess_pawn: _ChessPawn.default,
  cigarette: _Cigarette.default,
  clapper_board: _ClapperBoard.default,
  clapping_hands: _ClappingHands.default,
  closed_book: _ClosedBook.default,
  cloud: _Cloud.default,
  collision: _Collision.default,
  crown: _Crown.default,
  compass: _Compass.default,
  construction: _Construction.default,
  controller: _Controller.default,
  cowboy_hat_face: _CowboyHatFace.default,
  credit_card: _CreditCard.default,
  cricket_game: _CricketGame.default,
  crystal_ball: _CrystalBall.default,
  cycle: _Cycle.default,
  deciduous_tree: _DeciduousTree.default,
  defence: _Defence.default,
  desert_island: _DesertIsland.default,
  domestic_applicances: _DomesticApplicances.default,
  ear_of_corn: _EarOfCorn.default,
  eye: _Eye.default,
  factory: _Factory.default,
  feather: _Feather.default,
  ferry: _Ferry.default,
  fire: _Fire.default,
  fish: _Fish.default,
  flag_india: _FlagIndia.default,
  flag_in_hole: _FlagInHole.default,
  flexed_biceps: _FlexedBiceps.default,
  flying_saucer: _FlyingSaucer.default,
  fork_and_knife: _ForkAndKnife.default,
  four_leaf_clover: _FourLeafClover.default,
  french_fries: _FrenchFries.default,
  fuel_pump: _FuelPump.default,
  gem_stone: _GemStone.default,
  glass: _Glass.default,
  globe_showing_asia_australia: _GlobeShowingAsiaAustralia.default,
  graduation_cap: _GraduationCap.default,
  hot_beverage: _HotBeverage.default,
  house_with_garden: _HouseWithGarden.default,
  it: _IT.default,
  leaf_fluttering_in_wind: _LeafFlutteringInWind.default,
  leather: _Leather.default,
  light_bulb: _LightBulb.default,
  lipstick: _Lipstick.default,
  locked: _Locked.default,
  metal: _Metal.default,
  microphone: _Microphone.default,
  microscope: _Microscope.default,
  mobile_phone: _MobilePhone.default,
  money_mouth_face: _MoneyMouthFace.default,
  money_with_wings: _MoneyWithWings.default,
  mountain: _Mountain.default,
  neutral: _Neutral.default,
  newspaper: _Newspaper.default,
  iol_barrel: _OilBarrel.default,
  ox: _Ox.default,
  packaging: _Packaging.default,
  paint: _Paint.default,
  paper: _Paper.default,
  party_popper: _PartyPopper.default,
  pencil: _Pencil.default,
  performing_arts: _PerformingArts.default,
  petrol: _Petrol.default,
  photo: _Photo.default,
  pill: _Pill.default,
  plastic_bucket: _PlasticBucket.default,
  plug: _Plug.default,
  police_car_light: _PoliceCarLight.default,
  pool_8_ball: _Pool8Ball.default,
  popcorn: _Popcorn.default,
  printers: _Printers.default,
  purple_heart: _PurpleHeart.default,
  rainbow: _Rainbow.default,
  recycling_symbol: _RecyclingSymbol.default,
  rocket: _Rocket.default,
  rubber: _Rubber.default,
  rubber_button: _RubberButton.default,
  safety_vest: _SafetyVest.default,
  satellite: _Satellite.default,
  shark: _Shark.default,
  shield: _Shield.default,
  shoes: _Shoes.default,
  shooting_star: _ShootingStar.default,
  shopping_bags: _ShoppingBags.default,
  shopping_cart: _ShoppingCart.default,
  soap: _Soap.default,
  soccer_ball: _SoccerBall.default,
  sports_medal: _SportsMedal.default,
  stadium: _Stadium.default,
  star: _Star.default,
  star_struck: _StarStruck.default,
  station: _Station.default,
  stethoscope: _Stethoscope.default,
  sugar: _Sugar.default,
  textile: _Textile.default,
  thermometer: _Thermometer.default,
  thought_balloon: _ThoughtBalloon.default,
  toolbox: _Toolbox.default,
  tractor: _Tractor.default,
  travel: _Travel.default,
  trophy: _Trophy.default,
  truck: _Truck.default,
  two_hearts: _TwoHearts.default,
  umbrella_with_rain_drops: _UmbrellaWithRainDrops.default,
  volatile: _Volatile.default,
  watch: _Watch.default,
  wood: _Wood.default,
  wood_door: _WoodDoor.default,
  wrench: _Wrench.default
};
exports.EMOJI_NAME_MAP = EMOJI_NAME_MAP;

/**
 * Emoji are ideograms and smileys used in electronic messages and web pages.
 * The `Emoji` component renders a specific subset of designer-selected emoji,
 * using assets from the Twemoji library (https://twemoji.twitter.com/).
 *
 * It accepts a `name` prop that maps to an image asset, which will be loaded
 * on render.
 *
 * The size prop determines which design-selected sizes to render the
 * emoji icon at. It does this by setting the `width` attribute of the `<img>`
 * tag, although this can be overridden by passing your own width prop.
 *
 * The `Emoji` component will pass all unhandled props to the root image
 * element, thereby accepting all HTML img attributes.
 */
const Emoji = ({
  name,
  size = 'small',
  ...otherProps
}) => {
  const [isLoadingError, setIsLoadingError] = React.useState(false);
  const hasError = !name || !EMOJI_NAME_MAP[name] || isLoadingError;
  return (0, _pragma.createFelaElement)("img", _extends({
    alt: hasError ? 'default' : name,
    height: "auto",
    loading: "lazy",
    onError: () => setIsLoadingError(true),
    src: hasError ? EMOJI_NAME_MAP.flag_india : EMOJI_NAME_MAP[name] // there is no default emoji in assets
    ,
    width: size === 'small' ? 28 : 40
  }, otherProps));
};

Emoji.displayName = 'Emoji';
var _default = Emoji;
exports.default = _default;
//# sourceMappingURL=Emoji.js.map